import React, { useState, useEffect } from 'react'
import { useSelector } from "react-redux"
import { hoursFunctions } from '../restaurants/Hours'
import { tagFunctions } from '../restaurants/Tags'
import SortingOptions from '../users/SortingOptions'
import SearchBar from '../dashboard/SearchBar'
import HorizontalSlider from "../../infinite-carousel/HorizontalSlider"
import NewRestaurantList from '../restaurants/NewRestaurantList'
import useDistanceList from '../dashboard/DistanceList'
import NewChooseRestaurantList from './NewChooseRestaurantList'

function resizeEvent(sliderWidth, setSliderWidth){
    if(sliderWidth!==document.body.clientWidth){
      if(document.body.clientWidth<767){
        setSliderWidth(document.body.clientWidth - 20)
      } 
      else{
        setSliderWidth(document.body.clientWidth - 280)
      }
    }
  }

function NewChooseRestaurant(props) {

const [openList, setOpenList] = useState(false); 
const [primaryTags, setPrimaryTags] = useState(false); 
const [sliderWidth, setSliderWidth] = useState(false);

const restaurants = useSelector((state)=>state.firestore.ordered.restaurants);
const users = useSelector((state)=>state.firestore.data.users);
const userId = useSelector((state)=>state.firebase.auth.uid);

const [distanceList, setDistanceList] = useState(false);

useEffect(()=>{

if(users && userId && users[userId] && users[userId].distanceList){
	setDistanceList(users[userId].distanceList)
}

},[users, userId])

useEffect(()=>{

setOpenList(hoursFunctions.compileHours(restaurants));
setPrimaryTags(tagFunctions.compilePrimaryTags(restaurants));

},[restaurants])

useEffect(()=>{

	if(document.body.clientWidth<767){
    setSliderWidth(document.body.clientWidth - 20)
  } 
  else{
    setSliderWidth(document.body.clientWidth - 280)
  }
	window.addEventListener("resize", ()=>resizeEvent(sliderWidth, setSliderWidth));
	return () => window.removeEventListener("resize", ()=>resizeEvent(sliderWidth, setSliderWidth))

},[])

let distance = useDistanceList(false);
//console.log('distance')
//console.log(distance)

	return(
		<>
		<div className='topBar'>
      <div className="centerMe">
				<div className="wrapper4" style={{width:"250px", height:"calc(100vh - 70px)", position:"sticky", top:"70px", "alignSelf":"flex-start", overflow:"scroll"}}>
					<SortingOptions noWrapper="true"/>
				</div>
				<div className="wrapperTEST">
	        <div className="row2" id="sliderSize">
	          <div className="onTop">  
	            <SearchBar/>
	          </div>
	          {document.getElementById('sliderSize') && primaryTags && 
	            <div style={{width: sliderWidth, overflow: "hidden"}}>
	              <div className="sliderContainer" style={{paddingTop: "10px", display: "flex", flexFlow: "row", margin: "auto", overflowX: "scroll", overflowY: "hidden", height: "100px", width: sliderWidth }}>
	                <HorizontalSlider contents={primaryTags}/>
	              </div>
	            </div>
	          }
	          { distanceList && Object.entries(distanceList).length < Object.entries(restaurants).length &&
	            <div style={{ display: "flex", flexFlow: "column", margin: "auto", textAlign: "center"}}>
	              <span>{"Calculating distances " + Object.entries(distanceList).length + ' / ' + Object.entries(restaurants).length}</span>
	              <span>This will only happen when you first sign up, when you change your address, or when new restaurants are added.</span>
	            </div>
	          }
	          { distanceList &&
	          	<NewChooseRestaurantList gameId={props.match.params.gameId} choice={props.match.params.choice}/>	
	          }
	          
	        </div>
	      </div>
			</div>
		</div>
		</>
	);
}

export default NewChooseRestaurant;